var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1232_5442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1232_5442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48325 8.33332V1.56665H14.9333V6.61665H10.2833L8.48325 8.33332ZM10.0499 5.03332H13.3499V3.14998H10.0499V5.03332ZM12.9499 14.4166C11.7499 14.4166 10.4721 14.0889 9.11658 13.4333C7.76103 12.7778 6.49436 11.8583 5.31659 10.675C4.1277 9.51387 3.20825 8.26937 2.55825 6.94147C1.90825 5.61357 1.58325 4.32196 1.58325 3.06665V1.56665H6.11659L6.96658 5.29998L4.66659 7.39998C4.93501 7.81273 5.21045 8.19647 5.4929 8.5512C5.77536 8.90594 6.07232 9.24462 6.3838 9.56722C6.73899 9.92239 7.10547 10.2472 7.48325 10.5416C7.86103 10.8361 8.25547 11.0944 8.66658 11.3166L10.9166 9.03332L14.4333 9.84303V14.4166H12.9499ZM3.89992 5.99998L5.23325 4.74998L4.86659 3.14998H3.18325C3.16103 3.51665 3.20825 3.93054 3.32492 4.39165C3.44159 4.85276 3.63325 5.38887 3.89992 5.99998ZM10.0999 12.1166C10.4777 12.2944 10.9083 12.4472 11.3916 12.575C11.8749 12.7028 12.361 12.7833 12.8499 12.8166V11.103L11.3833 10.7833L10.0999 12.1166Z",
    fill: "#172128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.563fcfd815f3643a0df457acd65fdb94.svg";
export { ForwardRef as ReactComponent };